export const HIDDEN = 'HIDDEN';
export const MONTH = 'MONTH';
export const WEEK = 'WEEK';
